// React for Website

import React, { useState, useEffect } from "react";
//outsource
import { Col, Select, Form, Input } from "antd";
import { TERMS_OPTIONS, DEFAULT_TERM } from "../../../../store/string";

//components
const { TextArea } = Input;

const VoucherTerm = ({ shop, form }) => {
  // -------------------------- VAR --------------------------
  const [selected, setSelected] = useState("Default");
  const [disabled, setDisabled] = useState(true);
  const name = shop?.name || "";
  const address = shop?.address || "";
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const onChange = (value) => {
    // console.log("value", value);
    if (value === "Default" && name !== "" && address !== "") {
      const term = DEFAULT_TERM?.replaceAll("{{Shop name}}", name)?.replaceAll(
        "{{Shop Location}}",
        address
      );
      form.setFieldsValue({ term });
      setDisabled(true);
    }

    if (value === "None") {
      form.setFieldsValue({ term: "" });
      setDisabled(true);
    }

    if (value === "Custom" && name !== "" && address !== "") {
      const term = DEFAULT_TERM?.replaceAll("{{Shop name}}", name)?.replaceAll(
        "{{Shop Location}}",
        address
      );
      form.setFieldsValue({ term });
      setDisabled(false);
    }

    setSelected(value);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (shop) {
      const term = DEFAULT_TERM?.replaceAll("{{Shop name}}", name)?.replaceAll(
        "{{Shop Location}}",
        address
      );
      form.setFieldsValue({ term });
    }
  }, [shop]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Form.Item label="Terms">
        <Select
          showArrow
          placeholder="Please select Terms"
          value={selected}
          options={TERMS_OPTIONS}
          onChange={onChange}
          style={{ width: 300 }}
        />
      </Form.Item>
      <Form.Item
        name="term"
        rules={[
          {
            max: 1000,
            message: "Max length of the term is 1000 characters",
          },
        ]}
      >
        <TextArea
          disabled={disabled}
          rows={5}
          maxLength={1000}
          placeholder="Nothing"
        />
      </Form.Item>
    </>
  );
};

export default VoucherTerm;
